import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../Shared/TextInput/TextInput';
import React, {useState, useRef, useEffect} from 'react';
import {createOtpLoginStep1, createOtpLoginStep02, saveDumbLogin} from '../../../../utilities/authentication/authenticationSlice';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {formatPhoneNumber} from '../../../../utilities/StringHelpers/StringHelpers';
import {rolesKeys} from '../../OTPLoginBlock/Assets/variables';
import {getSelfCareData} from '../../../Page/SelfCarePage/SelfCareAsyncThunk';
import Loader from '../../../Shared/LocalLoader/LocalLoader';
import {refetchData} from '../../../Page/SelfCarePage/SelfCareSlice';

function CheckCodePopup(props) {
  const [code, setCode] = useState('');
  const [restrictCode, setRestrictCode] = useState('');
  const [errorInForm, setErrorForm] = useState('');
  const [errorInCode, setErrorCode] = useState('');
  const [currentPopUp, setCurrentPopUp] = useState('sendCode');
  const [contactNumber, setContactNumber] = useState('');
  const [needRestrictCode, setNeedRestrictCode] = useState(false);
  const [ticketId, setTicketId] = useState('');
  const codeRef = useRef();
  const restrictCodeRef = useRef();
  const title = props.title ? (
    props.title
  ) : (
    <>
      כדי להמשיך נדרשת
      <br />
      הסכמה מבעל החשבון
    </>
  );

  useEffect(() => {
    if (!props.showPopup) {
      setCurrentPopUp('');
      setCode('');
      setRestrictCode('');
      setErrorCode('');
      setErrorForm('');
      setTicketId('');
    } else {
      setCurrentPopUp('sendCode');
    }
  }, [props.showPopup]);

  let getCurrentPopUp = () => {
    if (props.isOtpExtendedAuthenticated && props.isLoadingExtendedData) {
      return loadingNewData();
    }
    switch (currentPopUp) {
      case 'sendCode':
        return SendCode();
      case 'validateCode':
        return validateCode();
      default:
        break;
    }
  };

  const sendSmsToContact = async () => {
    props.showAppLoader();
    await props
      .createOtpLoginStep1({phoneNumber: props.userDetails.contactNumber, isExtended: true})
      .then((res) => {
        var body = res.payload.Body;
        if (body.isSuccess) {
          props.hideAppLoader();
          setContactNumber(body.extra.contactNumber);
          setTicketId(body.message);
          if (body.resultMessage == 'OTP_RESTRICT_CODE_REQUIRE') {
            setNeedRestrictCode(true);
          }
          setCurrentPopUp('validateCode');
        }
      })
      .catch((err) => {
        props.hideAppLoader();
      });
  };

  const checkOtpStep2 = async () => {
    if (code !== '') {
      props.showAppLoader();
      var res = await props.createOtpLoginStep02({
        phoneNumber: props.userDetails.contactNumber,
        otpCode: code,
        guid: ticketId,
        restrictCode,
        termsAccepted: true,
        checkPhoneNumber: contactNumber,
        loginType: rolesKeys.OTPEXTENDED,
      });
      props.hideAppLoader();
      if (res.payload?.isSuccess) {
        if (props.setOtpExtendedFinished) props.setOtpExtendedFinished(true);
        props.refetchData();
      } else {
        setErrorForm('מממ.. זה לא הקוד ששלחנו, שננסה שוב?');
      }
    } else {
      setErrorForm('אנא הזן קוד אימות');
    }
  };

  const loadingNewData = () => {
    return (
      <div className='loadingNewData'>
        <p className='title'> כבר מחברים אותך לכל המנויים</p>
        <Loader />
      </div>
    );
  };

  const closePopUp = (
    <p className='purpleText' onClick={() => props.setShowPopUp(false)}>
      {' '}
      בפעם אחרת
    </p>
  );

  const validateCode = () => {
    return (
      <>
        <p className='title'>הזנת קוד אישור</p>
        <p className='greyText'>שלחנו הודעה לבעל החשבון {formatPhoneNumber(contactNumber)} עם קוד שיש להזין כאן </p>
        <TextInput
          ref={codeRef}
          value={code}
          id='code'
          placeholder={'קוד אימות'}
          maxLength={'6'}
          error={errorInForm}
          onChange={(e) => {
            const numberRegex = /^\d+$/;
            if (numberRegex.test(e.target.value) || e.target.value === '') {
              setCode(e.target.value);
              setErrorForm(null);
            }
          }}
          required='required'
        />
        {needRestrictCode && (
          <TextInput
            ref={restrictCodeRef}
            value={restrictCode}
            error={errorInCode}
            id='code'
            placeholder={'קוד זיהוי'}
            onChange={(e) => {
              setRestrictCode(e.target.value);
            }}
            required='required'
          />
        )}
        <BtnSubmit text={'המשך'} onclick={() => checkOtpStep2()} />
        {closePopUp}
      </>
    );
  };

  const SendCode = () => {
    return (
      <>
        <p className='title'>{title}</p>
        {props.subTitle && <p className='greyText'>{props.subTitle}</p>}
        <BtnSubmit text={'שלחו הודעה לבעל החשבון'} onclick={() => sendSmsToContact()} />
        {closePopUp}
      </>
    );
  };
  return <div className='CheckCodePopup'>{getCurrentPopUp()}</div>;
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.authentication.loginData.userDetails,
    isFetchData: state.selfcarePage?.isFetchData,
    isOtpExtendedAuthenticated: state.authentication.loginData.isOtpExtendedAuthenticated,
    isLoadingExtendedData: state.selfcarePage.isLoadingExtendedData,
  };
};
const mapDispatchToProps = {
  createOtpLoginStep1,
  createOtpLoginStep02,
  showAppLoader,
  hideAppLoader,
  saveDumbLogin,
  refetchData,
  getSelfCareData,
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckCodePopup);
